import React__default from 'react';

const SliderCarousel = ({ children , itemWidth =280  })=>/*#__PURE__*/ React__default.createElement("ul", {
        className: "slider-carousel"
    }, React__default.Children.map(children, (child, i)=>/*#__PURE__*/ React__default.createElement("li", {
            key: i,
            className: "slider-carousel__item",
            style: {
                minWidth: `calc(${itemWidth}px + 1rem)`
            }
        }, child)
    ))
;
var SliderCarousel$1 = SliderCarousel;

export { SliderCarousel$1 as default };
//# sourceMappingURL=SliderCarousel.js.map
